export const G2W = 'g2w';
export const G2S = 'g2s';
export const G2M = 'g2m';
export const G2T = 'g2t';

export const PNG = 'PNG';
export const XLS = 'XLS';
export const CSV = 'CSV';

export const MIN_RANGE = 0;
export const MAX_RANGE = 30000;
export const MAX_VE_SELECTED = 50;
export const SESSION_PAGE_COUNT = 20;
export const CREATORS_PAGE_COUNT = 100;
export const WEBINARS_PAGE_COUNT = 20;
export const RECORDINGS_PAGE_COUNT = 20;
export const VERTICAL_ORIENTATION = 'vertical';
export const HORIZONTAL_ORIENTATION = 'horizontal';
export const START_DATE = 'startDate';
export const HIGHCHARTS_MENU = 'HIGHCHARTS_MENU';
export const EXPERIENCED_TYPE_SIMULIVE = 'simulive';
export const RECURRENCE_PERIOD_SIMULIVE = 'anytime';

export const MOBILE_DEVICE = 'Mobile';
export const DESKTOP_DEVICE = 'Desktop';
// colors
export const DODGER_BLUE = '#0c9ae7';
export const DEEP_SKY_BLUE = '#00C2FF';

export class AnalyticsType {
  static get LIVE_ANALYTICS() {
    return 'LIVE_ANALYTICS';
  }
  static get RECORDING_ANALYTICS() {
    return 'RECORDING_ANALYTICS';
  }
}

export class RecordingChartType {
  static get VIEWS() {
    return 'VIEWS';
  }
  static get SHARES() {
    return 'SHARES';
  }
}

export class SessionDetailsTableType {
  static get REGISTRANTS() {
    return 'REGISTRANTS';
  }
  static get ATTENDEES() {
    return 'ATTENDEES';
  }
}

export class ReportType {
  static get SESSIONS_OVERVIEW_REPORT() {
    return 'SESSIONS_OVERVIEW_REPORT';
  }

  static get WEBINAR_ATTENDEE_REPORT() {
    return 'WEBINAR_ATTENDEE_REPORT';
  }

  static get WEBINAR_PERFORMANCE_REPORT() {
    return 'WEBINAR_PERFORMANCE_REPORT';
  }

  static get WEBINAR_QANDA_REPORT() {
    return 'WEBINAR_QANDA_REPORT';
  }

  static get WEBINAR_SURVEY_REPORT() {
    return 'WEBINAR_SURVEY_REPORT';
  }

  static get WEBINAR_REGISTRATION_REPORT() {
    return 'WEBINAR_REGISTRATION_REPORT';
  }

  static get WEBINAR_RECORDING_REPORT() {
    return 'WEBINAR_RECORDING_REPORT';
  }

  static get SESSIONS_ATTENDANCE_REPORT() {
    return 'SESSIONS_ATTENDANCE_REPORT';
  }

  static get SESSIONS_QANDA_FOLLOW_UP_REPORT() {
    return 'SESSIONS_QANDA_FOLLOW_UP_REPORT';
  }

  static get RECORDING_VIEWS_REPORT() {
    return 'RECORDING_VIEWS_REPORT';
  }

  static get VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT() {
    return 'VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT';
  }

  static get VIRTUAL_EVENT_REGISTRATION_REPORT() {
    return 'VIRTUAL_EVENT_REGISTRATION_REPORT';
  }

  static get MULTIPLE_VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT() {
    return 'MULTIPLE_VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT';
  }

  static get MULTIPLE_VIRTUAL_EVENT_REGISTRATION_REPORT() {
    return 'MULTIPLE_VIRTUAL_EVENT_REGISTRATION_REPORT';
  }
}

export class ReportFormat {
  static get XLSX() {
    return 'xlsx';
  }

  static get CSV() {
    return 'csv';
  }

  static get PDF() {
    return 'pdf';
  }
}

export class DateFilters {
  static get TODAY() {
    return 'TODAY';
  }
  static get LAST_SEVEN_DAYS() {
    return 'LAST_SEVEN_DAYS';
  }
  static get LAST_THIRTY_DAYS() {
    return 'LAST_THIRTY_DAYS';
  }
  static get LAST_NINETY_DAYS() {
    return 'LAST_NINETY_DAYS';
  }
  static get LAST_HUNDRED_EIGHTY_DAYS() {
    return 'LAST_HUNDRED_EIGHTY_DAYS';
  }
  static get LAST_YEAR() {
    return 'LAST_YEAR';
  }
  static get LAST_TWO_YEARS() {
    return 'LAST_TWO_YEARS';
  }
  static get NEXT_SEVEN_DAYS() {
    return 'NEXT_SEVEN_DAYS';
  }
  static get NEXT_THIRTY_DAYS() {
    return 'NEXT_THIRTY_DAYS';
  }
  static get NEXT_NINETY_DAYS() {
    return 'NEXT_NINETY_DAYS';
  }
  static get NEXT_HUNDRED_EIGHTY_DAYS() {
    return 'NEXT_HUNDRED_EIGHTY_DAYS';
  }
  static get NEXT_YEAR() {
    return 'NEXT_YEAR';
  }
}

export class RecordingSource {
  static get G2W() {
    return 'G2W';
  }
  static get G2S() {
    return 'G2S';
  }
  static get G2S_EMBEDDED() {
    return 'G2S_EMBEDDED';
  }
}

export const firstName = 'GIVEN_NAME';
export const lastName = 'SUR_NAME';
export const email = 'EMAIL';
export const registrationDateAndTime = 'REGISTRATION_TIME';
export const interestRating = 'INTEREST_RATING';
export const timeInSession = 'TIME_IN_SESSION';
export const pollResponseCount = 'POLL_ANSWERED_COUNT';
export const surveyQuestionAnsweredCount = 'SURVEY_QUESTION_ANSWERED_COUNT';
export const sessionQuestionCount = 'QUESTION_COUNT';

export class TimeRange {
  static get PREVIOUS() {
    return 'PREVIOUS';
  }
  static get FUTURE() {
    return 'FUTURE';
  }
}

export class RobotMessageState {
  static get EMPTY_STATE() {
    return 'emptyState';
  }
  static get ERROR_STATE() {
    return 'errorState';
  }
  static get NOT_FOUND_STATE() {
    return 'notFoundState';
  }
  static get SESSION_PROCESSING_STATE() {
    return 'sessionProcessingState';
  }
}

export class EngagementTabId {
  static get POLL_TAB() {
    return 'POLL_TAB';
  }
  static get SURVEY_TAB() {
    return 'SURVEY_TAB';
  }
  static get QANDA_TAB() {
    return 'QANDA_TAB';
  }
}

export class WebinarExperienceType {
  static get CLASSIC() {
    return 'CLASSIC';
  }
  static get WEBCAST() {
    return 'WEBCAST';
  }
  static get SIMULIVE() {
    return 'SIMULIVE';
  }
}

export class AnswererRoles {
  static get INTERNAL_ORGANIZER() {
    return 'INTERNAL_ORGANIZER';
  }

  static get PANELIST() {
    return 'PANELIST';
  }

  static get EXTERNAL_ORGANIZER() {
    return 'EXTERNAL_ORGANIZER';
  }
}

export class SortOrder {
  static get ASC() {
    return 'ASC';
  }
  static get DESC() {
    return 'DESC';
  }

  static getInverse(sortOrder) {
    return sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC;
  }
}

export class QAndAAnsweredOptions {
  static get ALL_POSTS() {
    return 'ALL_POSTS';
  }
  static get ANSWERED() {
    return 'ANSWERED';
  }
  static get UNANSWERED() {
    return 'UNANSWERED';
  }
}

export class QuestionType {
  static get SINGLE_CHOICE() {
    return 'singleChoice';
  }
  static get MULTIPLE_CHOICE() {
    return 'multipleChoice';
  }
  static get RATING() {
    return 'rating';
  }
  static get SHORT_ANSWER() {
    return 'shortAnswer';
  }
}

export class RegistrantsTableColumns {
  static get GIVEN_NAME() {
    return 'GIVEN_NAME';
  }
  static get SUR_NAME() {
    return 'SUR_NAME';
  }
  static get EMAIL() {
    return 'EMAIL';
  }

  static get REGISTRATION_TIME() {
    return 'REGISTRATION_TIME';
  }

  static get UNSUBSCRIBED() {
    return 'UNSUBSCRIBED';
  }
  static get STATUS() {
    return 'STATUS';
  }
  static get SOURCE() {
    return 'SOURCE';
  }
}

export class AttendeesTableColumns {
  static get INTEREST_RATING() {
    return 'INTEREST_RATING';
  }
  static get GIVEN_NAME() {
    return 'GIVEN_NAME';
  }
  static get SUR_NAME() {
    return 'SUR_NAME';
  }
  static get EMAIL() {
    return 'EMAIL';
  }

  static get TIME_IN_SESSION() {
    return 'TIME_IN_SESSION';
  }

  static get CERTIFICATE_SENT() {
    return 'CERTIFICATE_SENT';
  }

  static get POLL_ANSWERED_COUNT() {
    return 'POLL_ANSWERED_COUNT';
  }

  static get SURVEY_QUESTION_ANSWERED_COUNT() {
    return 'SURVEY_QUESTION_ANSWERED_COUNT';
  }

  static get QUESTION_COUNT() {
    return 'QUESTION_COUNT';
  }
}

export class SessionsTableVisibleColumns {
  static get DAY() {
    return 'sessionsTable_day';
  }
  static get DATE() {
    return 'sessionsTable_date';
  }
  static get START_TIME() {
    return 'sessionsTable_startTime';
  }
  static get REGISTRANT_COUNT() {
    return 'sessionsTable_registrantCount';
  }
  static get ATTENDEE_COUNT() {
    return 'sessionsTable_attendeeCount';
  }
  static get ATTENDANCE_RATE() {
    return 'sessionsTable_attendanceRate';
  }
}

export class VirtualEventsTableVisibleColumns {
  static get NAME() {
    return 'virtualEventsTable_name';
  }
  static get DATE() {
    return 'virtualEventsTable_date';
  }
  static get START_TIME() {
    return 'virtualEventsTable_startTime';
  }
  static get REGISTRANT_COUNT() {
    return 'virtualEventsTable_registrantCount';
  }
}

export class RecordingsTableVisibleColumns {
  static get PUBLISHED_DATE() {
    return 'recordingsTable_publishedDate';
  }
  static get VIEWS() {
    return 'recordingsTable_lastName';
  }
  static get SHARES() {
    return 'recordingsTable_email';
  }
  static get LENGTH() {
    return 'recordingsTable_registrationDateAndTime';
  }
  static get AVG_VIEW_DURATION() {
    return 'recordingsTable_status';
  }
  static get SOURCE() {
    return 'recordingsTable_source';
  }
}

export class RecordingViewsVisibleColumns {
  static get FIRST_NAME() {
    return 'recordingViewsTable_firstName';
  }

  static get LAST_NAME() {
    return 'recordingViewsTable_lastName';
  }

  static get EMAIL() {
    return 'recordingViewsTable_email';
  }

  static get LAST_WATCH_DATE() {
    return 'recordingViewsTable_lastWatchedDate';
  }

  static get AVG_PERC_VIEWED() {
    return 'recordingViewsTable_avgPercentageViewed';
  }

  static get VIEW_COUNT() {
    return 'recordingViewsTable_viewCount';
  }

  static get VIEW_DURATION() {
    return 'recordingViewsTable_viewDuration';
  }

  static get SOURCE_EMBEDDED_LINK() {
    return 'recordingViewsTable_sourceEmbeddedLink';
  }
}
export class UserSettings {
  static get CLASSIC_FRONTEND_EXPERIENCE() {
    return 'classicFrontendExperience';
  }
  static get CAN_TOGGLE_FRONTEND_EXPERIENCE() {
    return 'canToggleFrontendExperience';
  }
}

export const LIGHT_MODE = 'light-mode';
export const NEW_EXP_LIGHT_MODE = 'new-exp-light-mode';
export const DARK_MODE = 'dark-mode';

export const LIGHT_MODE_VARIABLES = {
  '--bg-cover': '$bg-cover',
  '--white-color': '#ffffff',
  '--charcoal-color': '#444444',
  '--rhino-color': '#434b58',
  '--dark-fantasy': '#444444',
  '--bg-color': 'white',
  '--bg-chart': '#ffffff',
  '--gray-chart': '#BEBEBE',
  '--white-smoke-table': '#f8f8f8',
  '--icon-color': '#444444',
  '--noData-color': 'rgba(0, 0, 0, 0.5)',
  '--noData-bgColor': 'rgba(255, 255, 255, 0.8)',
  '--border-color': 'rgba(0, 0, 0, 0.05)',
  '--simple-border': '#e0e3e7',
  '--gray-color': '#aaa',
  '--gray-calendar': '#484848',
  '--gray-calendar-disabled': '#cacccd',
  '--button-dark': '#ffffff',
  '--cross-color': '#000000',
  '--manatee-color': '#8b8d99',
  '--dark-fantasy-table-column': '#444444',
  '--new-exp-bg-cover': '$newExp-BgCover'
};

export const DARK_MODE_VARIABLES = {
  '--bg-cover': 'none',
  '--white-color': '#2A2A2A',
  '--charcoal-color': '#ffffff',
  '--rhino-color': '#ffffff',
  '--dark-fantasy': '#ffffff',
  '--bg-color': '#000000',
  '--bg-chart': '#444444',
  '--gray-chart': '#ffffff',
  '--white-smoke-table': '#444444',
  '--icon-color': '#8B8D99',
  '--noData-color': 'rgba(255,255,255,0.8)',
  '--noData-bgColor': '#2A2A2A',
  '--border-color': 'rgba(255,255,255,0.05)',
  '--simple-border': '#8b8d99',
  '--gray-color': '#555555',
  '--gray-calendar': '#FDFDFD',
  '--gray-calendar-disabled': '#4f4c4b',
  '--button-dark': '#c9cacc',
  '--cross-color': '#00C2FF',
  '--manatee-color': '#ffffff',
  '--dark-fantasy-table-column': '#8B8D99',
  '--new-exp-bg-cover': 'none'
};

export const ENGLISH_LOCALE = 'en_US';



// WEBPACK FOOTER //
// ./src/Utils/Constants.js